export default __webpack_public_path__ + "static/media/sec_adicionales.5ca8b675.png";